import { useTranslation } from 'react-i18next';
import QRCode from '../../../components/feature/QRCode';

export default function Contact() {
  const { t } = useTranslation();

  return (
    <section id="contacto" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {t('contact_title')}
          </h2>
          <p className="text-xl text-gray-600 mb-12 font-light">
            {t('contact_subtitle')}
          </p>
        </div>

        {/* Contact Information Banner */}
        <div className="bg-slate-900 rounded-3xl shadow-2xl p-12 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            {/* Phone */}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-orange-600 rounded-2xl flex-shrink-0">
                <i className="ri-phone-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-300 mb-2 uppercase tracking-wide">{t('contact_phone')}</h3>
                <a href="https://wa.me/16786931234" target="_blank" rel="noopener noreferrer" className="text-lg text-white hover:text-orange-400 transition-colors block cursor-pointer">
                  678 693 1234 {t('contact_spanish')}
                </a>
                <a href="tel://4705408595" className="text-lg text-white hover:text-orange-400 transition-colors block cursor-pointer">
                  470 540 8595 {t('contact_english')}
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-orange-600 rounded-2xl flex-shrink-0">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-300 mb-2 uppercase tracking-wide">{t('contact_email')}</h3>
                <a href="mailto:abrilweldworksprollc@gmail.com" className="text-lg text-white hover:text-orange-400 transition-colors break-all cursor-pointer">
                  abrilweldworksprollc@gmail.com
                </a>
              </div>
            </div>

            {/* Location */}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 flex items-center justify-center bg-orange-600 rounded-2xl flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-300 mb-2 uppercase tracking-wide">{t('contact_address')}</h3>
                <p className="text-lg text-white">
                  4055 Brushymill ct<br />
                  Loganville 30052
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* QR Codes Section - Separated Below */}
        <div className="bg-slate-900 rounded-3xl shadow-2xl py-16 px-12 mb-16">
          <h3 className="text-3xl font-bold text-white text-center mb-12">
            {t('contact_qr_title')}
          </h3>
          <QRCode size={280} />
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Calidad Garantizada</h3>
          </div>

          <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-4">
              <i className="ri-time-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Entrega a Tiempo</h3>
          </div>

          <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Soporte 24/7</h3>
          </div>

          <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-4">
              <i className="ri-award-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">15+ Años Experiencia</h3>
          </div>
        </div>
      </div>
    </section>
  );
}
